import React, { useState } from "react";
import { Button, Divider, Grid, Typography, TextField } from "@mui/material";
import { useFormik } from "formik";
import * as yup from "yup";
import { useNavigate } from "react-router";
import * as XLSX from "xlsx";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import ParentCard from "src/components/shared/ParentCard";
import CustomFormLabel from "src/components/forms/theme-elements/CustomFormLabel";
import BulkImeiService from "src/service/bulkdeviceadd";
import swal from "sweetalert";
import { IconArrowBack } from "@tabler/icons";

const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: "Upload vehicle",
  },
];

const validationSchema = yup.object({
  vehicle_data: yup.array().required("Please upload a valid file"),
});

const AddBulkvehicle = () => {
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const sessionData = JSON.parse(localStorage.getItem("user"));

  const initialValues = {
    vehicle_data: [],
    c_by: sessionData?.data?.id || "",
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      try {
        const res = await BulkImeiService.verify_vehicle_data(values);
        swal("Success", res.message, "success");
        setTimeout(() => {
          navigate("/vehicletable", { state: { vehicleData: res.data } });
        }, 1000);
      } catch (error) {
        swal("Error", error.message, "error");
        setError(error.message);
      }
    },
  });

  const handleFileChange = (event) => {
    const file = event.currentTarget.files[0];
    const reader = new FileReader();

    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(sheet);

      const vehicle_data = jsonData.map((item) => [
        item.VehicleNo, // assuming these keys match your Excel column headers
        item.ERVNo,
        JSON.stringify(item.ImeiNo),
        parseInt(item.District), // convert to integer if necessary
        item.VehicleType,
      ]);

      formik.setFieldValue("vehicle_data", vehicle_data);
      setError(null);
    };

    reader.readAsArrayBuffer(file);
  };

  return (
    <div>
      <Breadcrumb title="Upload Vehicle" items={BCrumb} />
      <ParentCard title="">
        <Grid container alignItems="center">
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h2"
            >
              Upload vehicle
            </Typography>
          </Grid>

          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                navigate("/bulkvehiclelist");
              }}
            >
              <IconArrowBack width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />

        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={3} style={{ marginTop: "0px" }}>
            <Grid item lg={6} md={6} sm={6} xs={12} sx={{ marginTop: "-5px" }}>
              <CustomFormLabel htmlFor="vehicle_data">
                Upload Vehicle File <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <TextField
                accept=".xlsx, .xls"
                id="vehicle_data"
                name="vehicle_data"
                type="file"
                onChange={handleFileChange}
                onBlur={formik.handleBlur}
                style={{ width: "100%" }}
              />
              {formik.errors.vehicle_data && formik.touched.vehicle_data && (
                <Typography variant="body2" color="error">
                  {formik.errors.vehicle_data}
                </Typography>
              )}
              {error && (
                <Typography variant="body2" color="error">
                  {error}
                </Typography>
              )}
            </Grid>

            <Grid item lg={6} md={12} sm={12} mt={4}>
              <Button color="primary" variant="contained" type="submit">
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </ParentCard>
    </div>
  );
};

export default AddBulkvehicle;
